import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from 'projects/authentication/_services/account.service';
import { ContentcmsService } from 'projects/authentication/_services/contentcms.service';
import { forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalService } from 'src/app/_core/global.service';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { EventsService } from 'src/app/_core/_services/events.service';
import { LangService } from 'src/app/_core/_services/lang.service';
import { ThemeService } from 'src/app/_core/_services/theme.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  public sliding: boolean = false;
  public Slides: any[];
  public categoryTitle: string;

  public homeSlideConfig: any;

  public uparInfoCms: any = {};

  public socialNetwork: any = {
    facebook: 'fab fa-facebook-square',
    discord: 'fab fa-discord',
    instagram: 'fab fa-instagram',
    twitter: 'fab fa-twitter',
    twitch: 'fab fa-twitch',
    youtube: 'fab fa-youtube'
  }

  public LightTheme$: boolean;

  constructor(
    private contSvc: ContentcmsService,
    private router: Router,
    public global: GlobalService,
    private beh: BehaviorService,
    private langSvc: LangService,
    private themeSvc: ThemeService,
    public event: EventsService,
    private accountSvc: AccountService,
    private tranlateSvc: TranslateService
  ) {
    this.themeSvc.lightTheme.subscribe(l => { this.LightTheme$ = l });
    this.langSvc.lang.subscribe(l => {
      this.homeSlideConfig = {
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: true,
        autoplay: true,
        arrows: false,
        dots: true,
        rtl: !!(l == 'ar')
      }
    });

    this.beh.initialCmsSetts.subscribe(cmsSetts => {
      if (!!cmsSetts) {
        this.categoryTitle = cmsSetts.homepage_settings_category_name || null;
        this.loadSlidItems();
        this.loadPortalInfo(cmsSetts);
      }
    });
  }

  ngOnInit(): void {
    this.event.eventStart({ eventType: 'HOME_PAGE_ACCESS', eventCategory: 'ACCESS' });

    this.remotePopUp();
  }

  private _subs = new Subject();
  ngOnDestroy() {
    this._subs.next();
    this._subs.complete();
  }

  private loadPortalInfo(setts) {
    if (!!this.beh.uparInfoCmsCallResp.value) {
      this.uparInfoCms = this.beh.uparInfoCmsCallResp.value;
    } else {
      forkJoin([
        this.contSvc.getContent('upar_advantages', { useCache: true }),
        this.contSvc.getContent('payment_methods', { useCache: true }),
        this.contSvc.getContent('social_media_list', { useCache: true }),
        this.contSvc.getContent('content', { useCache: true, withReferences: false, count: setts.count, order: setts.order, orderBy: setts.order_by, keywords: [setts.homepage_settings_category_name] })
      ]).pipe(takeUntil(this._subs)).subscribe(res => {
        this.uparInfoCms.uparAdvantages = this.global.entitysToPlain(res[0]?.list || []);
        this.uparInfoCms.paymentMethods = this.global.entitysToPlain(res[1]?.list || []);
        this.uparInfoCms.socialMediaList = this.global.entitysToPlain(res[2]?.list || []);
        this.uparInfoCms.popVouchers = this.global.entitysToPlain(res[3]?.list || []);
        this.beh.uparInfoCmsCallResp.next(this.uparInfoCms);
      }, noRes => { console.debug('nores', noRes) });
    }
  }

  private loadSlidItems() {
    if (this.beh.sliderCallResp.value) {
      this.Slides = this.beh.sliderCallResp.value;
    } else {
      this.contSvc.getContent('slider', { useCache: true, withReferences: true }).pipe(takeUntil(this._subs)).subscribe(contents => {
        this.Slides = !!contents?.list?.length ? this.global.entitysToPlain(contents.list)[0]['content_ref'] || [] : [];
        this.beh.sliderCallResp.next(this.Slides);
      }, () => { this.Slides = [] });
    }
  }

  private remotePopUp() {
    this.accountSvc.getPopInbox().pipe(takeUntil(this._subs)).subscribe(pop => {
      !!pop.inbox?.length && this.beh.popup.next({ pop: 'custom', extraData: pop.inbox[0].popupAttributes });
    });
  }

  public navigate(slide, isbanner: boolean = false) {
    isbanner && this.event.eventStart({ eventType: 'BANNER_CLICK', eventCategory: 'CLICK' });

    if (slide.type == 'SLIDER') {
      slide.category == 'PAGE' ? this.router.navigate([slide.web_app_url]) : window.open(slide.web_app_url);
    } else {
      this.router.navigate(['voucher', slide.value || slide.id], { queryParamsHandling: 'merge' });
    }
  }

  public gotoSearch(val) {
    this.beh.showSideNav.next(false);
    this.router.navigate(['search'], { queryParams: { q: val }, queryParamsHandling: 'merge' });
  }

  /* public supportPopUp(supportEmail: string) {
    this.beh.popup.next({
      pop: 'custom',
      extraData: {
        subtitle: 'home.supportContact',
        description: this.tranlateSvc.instant('home.supportEmail', { support: supportEmail }),
        popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icon_email.png',
        dark_popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icon_email_dark.png',
        button_action_type: 'ACTION',
        button_action: 'CLOSE',
        button_text: 'global.continue'
      }
    });
  } */

}
